import { env } from "../env"

const USER_ACCOUNT_URL = `${env.REACT_APP_KEYCLOAK_BASE_URL}/account`
const USER_DEVICES_URL = `${env.REACT_APP_KEYCLOAK_BASE_URL}/account/sessions/devices`
const USER_LINKED_CLINICS_URL = `${env.REACT_APP_ID_API_BASE_URL}/clinics/linked`

export { USER_ACCOUNT_URL, USER_DEVICES_URL, USER_LINKED_CLINICS_URL }
